module.exports = __webpack_public_path__ + "img/KSC01325.effc5728.jpg";